import {
    Component, ViewContainerRef, ViewChild, Injector, ComponentFactoryResolver,
    Input, ViewEncapsulation
} from '@angular/core';
import {Subscription} from "rxjs";

import {MetaFormComponent} from "../../_modules/estudio/meta-form/meta-form.component";
import {UnidadFormComponent} from "../../_modules/estudio/unidad-form/unidad-form.component";
import {GlmModalService} from "./glm-modal.service";
import {EventoFormComponent} from "../../_modules/estudio/evento-form/evento-form.component";
import {MetaListComponent} from "../../_modules/estudio/meta-list/meta-list.component";
import {MetaCriteriosListComponent} from "../../_modules/estudio/meta-criterios-list/meta-criterios-list.component";
import {GlmComentariosComponent} from "../glm-comentarios/glm-comentarios.component";
import {EventoListComponent} from "../../_modules/estudio/evento-list/evento-list.component";

@Component({
    selector: 'glm-modal',
    standalone: false,
    templateUrl: './glm-modal.component.html',
    styleUrls: ['./glm-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class GlmModalComponent {
    public showModal: boolean = false;
    titulo: string = "";
    subscription: Subscription;

    modalConfig: any = {
        width: '60%',
        left: '20%',
        height: '80%',
        top: '10%',
    };

    currComponent = null;
    @ViewChild('contenedorDinamico', { read: ViewContainerRef, static: true }) contenedorDinamico: ViewContainerRef;

    // component: Class for the component you want to create
    // inputs: An object with key/value pairs mapped to input name/input value
    @Input()
    set componentData(data: { component: any, inputs: any, titulo: string, config?: any }) {
        if (!data) {
            return;
        }

        if (data.config != null) {
            this.modalConfig = Object.assign({}, this.modalConfig, data.config);
        }

        // Inputs need to be in the following format to be resolved properly
        let inputProviders = Object.keys(data.inputs).map((inputName) => {
            return {provide: inputName, useValue: data.inputs[inputName]};
        });
        // let resolvedInputs = ReflectiveInjector.resolve(inputProviders);

        // We create an injector out of the data we want to pass down and this components injector
        let injector = Injector.create({providers: [inputProviders]});
        // let injector = Injector.create(inputProviders, this.contenedorDinamico.parentInjector);

        // We create a factory out of the component we want to create
        let factory = this.resolver.resolveComponentFactory(data.component);

        // We create the component using the factory and the injector
        let component = factory.create(injector);

        // We insert the component into the dom container
        this.contenedorDinamico.insert(component.hostView);

        // Destroy the previously created component
        if (this.currComponent) {
            this.currComponent.destroy();
        }

        // Se asigna el título a la variable.
        this.titulo = data.titulo;

        this.currComponent = component;
        this.showModal = true;
    }

    constructor(private resolver: ComponentFactoryResolver,
                private modalService: GlmModalService) {

    }

    ngOnInit() {
        this.modalService.getModalObservable().subscribe(data => {
            if (!data) {
                return;
            }
            if (data.accion == 'cerrar-modal') {
                this.close();
            }
        });
    }

    /**
     * Cierra la instancia actual del modal.
     */
    close() {
        let that = this;
        this.currComponent.destroy();
        this.showModal = false;
    }

}
